import {
  SET_CC_CANDIDATES,
  SET_CC_PRIMARY,
  TOGGLE_CC_COMPARISON,
  RESET_CC,
  CandidateItem,
  CandidatesComparisonActions
} from "../types/candidatesComparison";

export const setCandidates = (data: CandidateItem[]): CandidatesComparisonActions => ({
  type: SET_CC_CANDIDATES,
  payload: data
});

export const setPrimaryCandidate = (id: string): CandidatesComparisonActions => ({
  type: SET_CC_PRIMARY,
  payload: id
});

export const toggleComparisonCandidate = (id: string): CandidatesComparisonActions => ({
  type: TOGGLE_CC_COMPARISON,
  payload: id
});

export const resetCandidatesComparison = (): CandidatesComparisonActions => ({
  type: RESET_CC
});